// @flow

import Settings from '@/lib/settings';
import Cell from '@/lib/cell';

export default class {
  static process(cell: Cell) {
    cell.sunlight = Settings.sunlight;
    cell.soilNutrition = cell._defaultSoilNutrition;
    cell.green = cell._defaultGreen;
    cell.water = cell._defaultWater;
  }
}



// WEBPACK FOOTER //
// ./src/lib/cell_event/reset_parameters.js